var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.model)?_c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":'https://lurker.blob.core.windows.net/companies/d_comp_' + _vm.model.id + '.jpg'}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }